import React from 'react'
import Header from '../standartComponents/header';
import css from './info.module.css';
import Policies from '../standartComponents/policies';
import { useTranslation } from 'react-i18next';

const PrivacyPolicy = ({authUser}) => {
   const { t } = useTranslation();

  return (
    <div>
      <Header authUser={authUser} />
      <div className={css.privacyContainer}>
        <div className={css.contentWrapper}>
          <h1 className={css.pageTitle}>{t("Privacy Policy")}</h1>
          <span className={css.bottomLine}></span>
          <p className={css.lastUpdated}>{t("Last updated")}: 13 {t("October")} 2025</p>
          
          <div className={css.section}>
            <h2 className={css.sectionTitle}>{t("Who We Are")}</h2>
            <p className={css.sectionText}>
              {t("privacy1")} <a href="mailto:ailinguaservice@gmail.com">ailinguaservice@gmail.com</a>, <a href="tel:+380682507477">+380 68 250 74 77</a>.
            </p>
          </div>

          <div className={css.section}>
            <h2 className={css.sectionTitle}>{t("Data We Process")}</h2>
            <p className={css.sectionText}>
              <strong>• {t("Account")}:</strong> {t("privacy2")}
            </p>
            <p className={css.sectionText}>
              <strong>• {t("Learning")}:</strong> {t("privacy3")}
            </p>
            <p className={css.sectionText}>
              <strong>• {t("Payments")}:</strong> {t("privacy4")}
            </p>
            <p className={css.sectionText}>
              <strong>• {t("Technical")}:</strong> {t("privacy5")}
            </p>
          </div>

          <div className={css.section}>
            <h2 className={css.sectionTitle}>{t("Purposes")}</h2>
            <p className={css.sectionText}>
              {t("privacy6")}
            </p>
          </div>

          <div className={css.section}>
            <h2 className={css.sectionTitle}>{t("Legal Bases")}</h2>
            <p className={css.sectionText}>
              {t("privacy7")}
            </p>
          </div>

          <div className={css.section}>
            <h2 className={css.sectionTitle}>{t("Data Sharing")}</h2>
            <p className={css.sectionText}>
              {t("privacy8.1")} <a href="http://paddle.com/" target='_blanc'>Paddle.com</a> {t("privacy8.2")}
            </p>
          </div>

          <div className={css.section}>
            <h2 className={css.sectionTitle}>{t("Retention")}</h2>
            <p className={css.sectionText}>
              {t("privacy9")}
            </p>
          </div>

          <div className={css.section}>
            <h2 className={css.sectionTitle}>{t("Data Subject Rights")}</h2>
            <p className={css.sectionText}>
              {t("privacy10")}
            </p>
          </div>

          <div className={css.section}>
            <h2 className={css.sectionTitle}>{t("International Transfers")}</h2>
            <p className={css.sectionText}>
              {t("privacy11")}
            </p>
          </div>

          <div className={css.section}>
            <h2 className={css.sectionTitle}>{t("Cookies")}</h2>
            <p className={css.sectionText}>
              {t("privacy12")}
            </p>
          </div>
        </div>
      </div>
      <Policies />
    </div>
  )
}

export default PrivacyPolicy